// extracted by mini-css-extract-plugin
export default {"notificationContainer":"Notifications_notificationContainer__tMDfr","bellIcon":"Notifications_bellIcon__KLjV3"};